import React from "react";
import pic from "./profile-pic.jpg";

const Slider = () => {
  return (
    <section className="testimonials" id="slider">
      <div className="container pt-8">
        <div className="about-me-text mt-5 text-center position-relative">
          <h1 className="position-absolute know-text">What Clients Speak ?</h1>
          <h1 className="about-me-txt text-muted">testimonials</h1>
        </div>

        <div className="row mt-5">
          <div className="col-md-6 mt-3">
            <div className="inner-test p-5">
              <span
                className="d-flex"
                style={{ gap: "30px", alignItems: "center" }}
              >
                <img src={pic} alt="pic" />
                <h4 className="text-light">Asim Cattery</h4>
              </span>
              <p className="mt-5 text-light text-18px fw-600">
                "Afeef is an outstanding web developer! They skillfully brought my cattery website vision to life, and their expertise, responsiveness, and creative input made the entire process seamless and enjoyable. I highly recommend them! "
              </p>
            </div>
          </div>
          <div className="col-md-6 mt-3">
            <div className="inner-test p-5">
              <span
                className="d-flex"
                style={{ gap: "30px", alignItems: "center" }}
              >
                <img src={pic} alt="pic" />
                <h4 className="text-light">Ismail Shiek - Freelancer</h4>
              </span>
              <p className="mt-5 text-light text-18px fw-600">
                "As a web developer, I had the pleasure of collaborating with Mohd Afeef Ali. Their valuable input, creative ideas, and dedication significantly contributed to crafting an outstanding website. Excellent teamwork "
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slider;
